import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Data, Router} from '@angular/router';
import {IUser, Principal, UserService} from '@app/core';
import {JhiAlertService, JhiEventManager} from 'ng-jhipster';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatOption} from '@angular/material/core';
import {MatSelect} from '@angular/material/select';
import {VaiTroService} from '@entities/vai-tro/vai-tro.service';
import {DonViService} from '@entities/don-vi/don-vi.service';
import {IDonVi, DonVi} from '@entities/don-vi/don-vi.model';
import {HttpResponse} from '@angular/common/http';
import {IVaiTro} from '@entities/vai-tro/vai-tro.model';
import {Title} from '@angular/platform-browser';
import {LocalStorageService} from 'ngx-webstorage';
import {LocationService} from '@shared/services/location.service';
import {TranslateService} from '@ngx-translate/core';
import {
  Country,
  City,
  District,
  SubDistrict,
} from '@shared/model/location.model';

enum VAI_TRO {
  ADMIN = 1,
  QUAN_LY = 2,
  KTV = 3,
  QUAN_LY_DV = 4,
  NHAN_VIEN_DV = 5,
}

@Component({
  selector: 'app-user-management-update-dialog',
  templateUrl: './user-management-update.component.html',
})
export class UserManagementUpdateDialogComponent implements OnInit {
  currentAccount: IUser;
  user: IUser;
  donVis: IDonVi[];
  listRoles: IVaiTro[];
  authorities: any[];
  isSaving: boolean;
  plants = [];
  isMultiple: boolean;
  iShowDonVi = false;
  listCountry: Country[] = [];
  listCity: City[] = [];
  listDistrict: District[] = [];
  listSubDistrict: SubDistrict[] = [];
  @ViewChild('allSelected', {static: false}) private allSelected: MatSelect;
  constructor(
    private dialogRef: MatDialogRef<UserManagementUpdateDialogComponent>,
    private principal: Principal,
    private userService: UserService,
    private eventManager: JhiEventManager,
    private titleService: Title,
    private location: LocationService,
    private alertService: JhiAlertService,
    private donViService: DonViService,
    private translate: TranslateService,
  ) {
    this.isSaving = false;
    this.isMultiple = false;
    this.listRoles = [];
    this.donVis = [];
  }

  ngOnInit() {
    this.principal.identity().then((account) => {
      this.currentAccount = account;
      if (this.scopeOnly() && !this.user.scope) {
        this.user.scope = this.currentAccount.scope;
      }
    });
    if (this.user.id !== null) {
      this.titleService.setTitle(
        this.translate.instant(
          'admin.user-management.user-management-update.Sửa người dùng_title',
        ),
      );
      this.loadAllDonVi(this.user.roleId, false);
    } else {
      this.titleService.setTitle(
        this.translate.instant(
          'admin.user-management.user-management-update.Thêm người dùng_title',
        ),
      );
    }
    this.getCountry();
    if (this.user.countryId) {
      this.getCity(this.user.countryId);
    }
    if (this.user.cityId) {
      this.getDistrict(this.user.cityId);
    }
    if (this.user.districtId) {
      this.getSubDistrict(this.user.districtId);
    }
  }

  clear() {
    this.dialogRef.close('cancel');
  }

  save() {
    this.isSaving = true;
    if (this.user.id !== null) {
      this.userService.update(this.user).subscribe(
        () => this.onSaveSuccess(),
        () => this.onSaveError(),
      );
    } else {
      this.userService.create(this.user).subscribe(
        () => this.onSaveSuccess(),
        () => this.onSaveError(),
      );
    }
  }

  scopeOnly() {
    // TODO: 27022019 Need to fix scope
    // return this.currentAccount.scope !== 'ALL';
    return true;
  }

  onVaiTroChange(event: number) {
    this.loadAllDonVi(event, true);
  }

  private onSaveSuccess() {
    this.isSaving = false;
    this.eventManager.broadcast({
      name: 'userListModification',
      content: 'User',
    });
    this.dialogRef.close(true);
  }

  private onSaveError() {
    this.isSaving = false;
  }
  getCountry() {
    this.location.listCountry().subscribe(
      (res: HttpResponse<Country[]>) => this.onSuccess(res.body, 'country'),
      (res: HttpResponse<any>) => this.onError(res.body),
    );
  }

  getCity(id) {
    this.location.listCity(id).subscribe(
      (res: HttpResponse<City[]>) => this.onSuccess(res.body, 'city'),
      (res: HttpResponse<any>) => this.onError(res.body),
    );
  }

  getDistrict(id) {
    this.location.listDistrict(id).subscribe(
      (res: HttpResponse<District[]>) => this.onSuccess(res.body, 'district'),
      (res: HttpResponse<any>) => this.onError(res.body),
    );
  }

  getSubDistrict(id) {
    this.location.listSubDistrict(id).subscribe(
      (res: HttpResponse<SubDistrict[]>) =>
        this.onSuccess(res.body, 'subdistrict'),
      (res: HttpResponse<any>) => this.onError(res.body),
    );
  }

  private onSuccess(data: any, type: string) {
    if (type === 'country') {
      this.listCountry = data;
    } else if (type === 'city') {
      this.listCity = data;
    } else if (type === 'district') {
      this.listDistrict = data;
    } else if (type === 'subdistrict') {
      this.listSubDistrict = data;
    }
  }

  private onError(error: any) {
    this.alertService.error(error.error, error.message, null);
  }

  loadAllDonVi(roleId: number, changeValue: boolean) {
    this.donViService.donviByRole(roleId).subscribe(
      (res: HttpResponse<IDonVi[]>) => {
        const data = res.body;
        if (data.length > 0) {
          this.donVis = data;
          if (changeValue) {
            this.user.customerId = data[0].id;
          }
          this.iShowDonVi = true;
        } else {
          this.donVis = [];
          this.iShowDonVi = false;
          this.user.customerId = null;
        }
      },
      (res: HttpResponse<any>) => this.onError(res.body),
    );
  }
  countryEffect(country) {
    if (country) {
      this.getCity(country);
      this.listDistrict = [];
      this.listSubDistrict = [];
      this.user.cityId = null;
      this.user.districtId = null;
      this.user.wardId = null;
    } else {
      this.listCity = [];
      this.listDistrict = [];
      this.listSubDistrict = [];
      this.user.cityId = null;
      this.user.districtId = null;
      this.user.wardId = null;
    }
  }

  cityEffect(city) {
    if (city) {
      this.getDistrict(city);
      this.user.districtId = null;
      this.user.wardId = null;
      this.listSubDistrict = [];
    } else {
      this.user.districtId = null;
      this.user.wardId = null;
      this.listSubDistrict = [];
      this.listDistrict = [];
    }
  }

  districtEffect(district) {
    if (district) {
      this.getSubDistrict(district);
      this.user.wardId = null;
    } else {
      this.user.districtId = null;
      this.user.wardId = null;
      this.listSubDistrict = [];
    }
  }
}

@Component({
  selector: 'app-user-management-update-popup',
  template: '',
})
export class UserManagementUpdatePopupComponent implements OnInit, OnDestroy {
  private dialogRef: MatDialogRef<UserManagementUpdateDialogComponent>;

  constructor(
    private vaiTroService: VaiTroService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private alertService: JhiAlertService,
    private dialog: MatDialog,
    private titleService: Title,
    private localStorage: LocalStorageService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.activatedRoute.data.subscribe(({user, authorities}: Data) => {
      setTimeout(() => {
        this.dialogRef = this.dialog.open(UserManagementUpdateDialogComponent, {
          disableClose: true,
          width: '500px',
        });
        this.dialogRef.componentInstance.user = user;
        this.loadAllVaiTro();
        this.dialogRef.componentInstance.authorities = authorities;
        this.dialogRef.afterClosed().subscribe(
          (result) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
            this.dialogRef = null;
          },
          (reason) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
            this.dialogRef = null;
          },
        );
      }, 0);
    });
  }

  loadAllVaiTro() {
    this.vaiTroService.rolesDropdown().subscribe(
      (res: HttpResponse<IVaiTro[]>) => this.onSuccess(res.body),
      (res: HttpResponse<any>) => this.onError(res.body),
    );
  }

  private onSuccess(data: any) {
    this.dialogRef.componentInstance.listRoles = data;
  }

  private onError(error: any) {
    this.alertService.error(error.error, error.message, null);
  }

  ngOnDestroy(): void {
    this.titleService.setTitle(
      this.translate.instant(
        'admin.user-management.user-management.Danh sách người dùng_title',
      ),
    );
    this.dialogRef = null;
  }
}
